import { getCommunitySnapshot } from '@/Groups/Portfolios/private/api/getCommunitySnapshot';
import { periodStorage } from '@/Groups/Portfolios/private/utils/periodStorage';
import { PORTFOLIOS_STAFF_ONLY } from '@shared/constants/featureFlags.js';

const Portfolios = {
  namespaced: true,

  state: {
    snapshot: null,
    period: periodStorage.getPeriod(),
    status: 'idle',
    isLoading: false,
  },

  actions: {
    async loadSnapshot({ commit }) {
      commit('SET_LOADING', true);
      try {
        const result = await getCommunitySnapshot();
        commit('SET_SNAPSHOT', result.data ?? null);
        commit('SET_STATUS', result.status);
      } catch (err) {
        console.error('Ошибка загрузки портфелей комьюнити:', err);
        commit('SET_STATUS', 'error');
      } finally {
        commit('SET_LOADING', false);
      }
    },

    setPeriod({ commit }, period) {
      commit('SET_PERIOD', period);
      periodStorage.setPeriod(period);
    },
  },

  mutations: {
    SET_SNAPSHOT(state, snapshot){ state.snapshot = snapshot; },
    SET_STATUS(state, status){ state.status = status; },
    SET_LOADING(state, status){ state.isLoading = status; },
    SET_PERIOD(state, period){ state.period = period; },
  },

  getters: {
    //Раздел виден в навигации и в Портфеле: пока на согласовании — только модераторам и редакторам
    isVisible: (state, getters, rootState, rootGetters) => !PORTFOLIOS_STAFF_ONLY || Boolean(rootGetters['UserSystem/hasModeratorPrivileges']),
    //Данные раздела доступны: видимость + платная подписка (модераторы и редакторы проходят всегда)
    hasAccess: (state, getters, rootState, rootGetters) => (PORTFOLIOS_STAFF_ONLY
      ? Boolean(rootGetters['UserSystem/hasModeratorPrivileges'])
      : Boolean(rootGetters['UserSystem/hasPaidAccess'])),
    snapshot: (state) => state.snapshot,
    period: (state) => state.period,
    status: (state) => state.status,
    isLoading: (state) => state.isLoading,
    people: (state) => state.snapshot?.people ?? [],
    tokens: (state) => state.snapshot?.tokens ?? [],
    tokenMap: (state) => new Map((state.snapshot?.tokens ?? []).map((token) => [token.key, token])),
    //Новые ключи может не быть в старом снапшоте (undefined); popularity === null — истории для сравнения нет
    me: (state) => state.snapshot?.me,
    sectors: (state) => state.snapshot?.sectors ?? [],
    risk: (state) => state.snapshot?.risk ?? null,
    popularity: (state) => state.snapshot?.popularity,
    //null / undefined — блок скрыт (старый снапшот или мало истории)
    long: (state) => state.snapshot?.long ?? null,
    mentions: (state) => state.snapshot?.mentions ?? [],
  },
};

export default Portfolios;
